module.exports = __webpack_public_path__ + "media/steve.783ea8ab.wav";